<template>
  <div
    class="mandala-evaluation-preview-item"
    :class="[ isCol && 'col col-12 col-md-4' ]">
    <div class="d-flex align-items-center justify-content-between pb-2">
      <MiniButton
        class="mr-2"
        @click="onClickUser">
        {{ department ? department.name : '-' }}
      </MiniButton>
      <div
        class="mandala-evaluation-preview-item__user-wrapper"
        @click="onClickUser">
        <PreviewUser
          :user="user"
          :selected="selected" />
      </div>
      <div
        class="mandala-evaluation-preview-item__template-name">
        <template v-if="mandalaGoalTemplate">
          [{{ mandalaGoalTemplate.name | truncate }}]
        </template>
      </div>
    </div>
    <LikeButton :active="isLiked">
      いいね済み
    </LikeButton>
    <CenteredBox :offset-y="chartMessageOffsetY">
      <div @click="$emit('click')">
        <MandalaEvaluationsRadarChart
          :year-months="yearMonths"
          :mandala-evaluations="mandalaEvaluations"
          :display-legend="displayLegend"
          :styles="chartStyles"
          :padding="chartPadding"
          :device-pixel-ratio="adjustedDevicePixelRatio" />
      </div>
      <template #child>
        <OnChartMessage
          v-if="!isCurrentYearMonthMandalaEvaluationSubmitted"
          :value="true">
          未提出
        </OnChartMessage>
      </template>
    </CenteredBox>
  </div>
</template>

<script>
import MandalaEvaluationsRadarChart from '@/components/charts/MandalaEvaluationsRadarChart.vue'
import PreviewUser from '@/components/parts/PreviewUser.vue'
import MiniButton from '@/components/parts/MiniButton.vue'
import LikeButton from '@/components/parts/LikeButton.vue'
import OnChartMessage from '@/components/parts/OnChartMessage.vue'
import CenteredBox from '@/components/parts/CenteredBox.vue'
export default {
  components: {
    PreviewUser,
    MiniButton,
    LikeButton,
    MandalaEvaluationsRadarChart,
    OnChartMessage,
    CenteredBox
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    mandalaEvaluations: {
      type: Array,
      default: () => []
    },
    yearMonths: {
      type: Array,
      required: true
    },
    likeIds: {
      type: Array,
      default: () => []
    },
    mandalaGoalTemplate: {
      type: Object,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    isCol: {
      type: Boolean,
      default: true
    },
    chartStyles: {
      type: Object,
      default: () => {}
    },
    chartPadding: {
      type: Object,
      default: () => {}
    },
    chartMessageOffsetY: {
      type: Number,
      default: 0
    },
    displayLegend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentYearMonth() {
      return this.yearMonths[0]
    },
    currentYearMonthMandalaEvaluation() {
      if (this.mandalaEvaluations.length === 0) {
        return null
      }
      if (this.mandalaEvaluations[0].yearMonth !== this.currentYearMonth) {
        return null
      }
      return this.mandalaEvaluations[0]
    },
    hasCurrentYearMonthMandalaEvaluation() {
      return this.currentYearMonthMandalaEvaluation !== null
    },
    isCurrentYearMonthMandalaEvaluationSubmitted() {
      if (!this.hasCurrentYearMonthMandalaEvaluation) {
        return false
      }
      return this.currentYearMonthMandalaEvaluation.status === 'submitted'
    },
    isLiked() {
      if (!this.hasCurrentYearMonthMandalaEvaluation) {
        return false
      }
      return this.likeIds.includes(this.currentYearMonthMandalaEvaluation.id)
    },
    department() {
      return this.user.department
    },
    /**
     * iPhone13以降のRetinaディスプレイで表示する場合、canvasのメモリが足りなくなるため、0.75倍して調整する
     */
    adjustedDevicePixelRatio() {
      const newAdjustedDevicePixelRatio = window.devicePixelRatio * 0.75
      return newAdjustedDevicePixelRatio > 1 ? newAdjustedDevicePixelRatio : 1
    }
  },
  methods: {
    onClickUser() {
      this.$router.push({
        path: `/members/${this.user.id}/mandala_evaluation`,
        query: {
          yearMonth: this.currentYearMonth,
          isOpenSelectedMember: true
        }
      })
    }
  }
}
</script>

<style lang="scss">
.mandala-evaluation-preview-item {
  .mini-button {
    color: $white !important;
    background-color: $primary !important;
  }
}
</style>

<style lang="scss" scoped>
.mandala-evaluation-preview-item {

  break-inside: avoid;
  &__user-wrapper {
    cursor: pointer;
  }

  &__template-name {
    min-width: 66px;
    color: $grey08;
    font-size: $fs-s;
    font-weight: bold;
  }
}

</style>